export const SENTRY_DSN = import.meta.env.SENTRY_DSN;
export const ENVIRONMENT = import.meta.env.ENVIRONMENT;
